import React from "react";

const PageNotFound = () => {
  return (
    <div>
      <h1>Page Not Found</h1>
      <p>Not sure where you came from, but maybe try going back there.</p>
    </div>
  );
};

export default PageNotFound;
